import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#030303] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <Link to="/" className="block mb-5 w-fit group">
              <img
                src="/logo.png"
                alt="Nova Clean Service"
                className="h-20 w-auto transition-transform group-hover:scale-105"
              />
            </Link>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm mb-6">
              Nettoyage auto, mobilier textile, surfaces extérieures et petite mécanique — à domicile. 100% autonome, résultat de concession, à Versailles et dans les alentours.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#E50914]/10 border border-[#E50914]/30 rounded">
              <span className="w-1.5 h-1.5 rounded-full bg-[#E50914] pulse-red"></span>
              <span className="text-xs uppercase tracking-wider text-white font-semibold">Disponible · 20 km autour de Versailles</span>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4 font-mono">// Navigation</div>
            <ul className="space-y-2.5 text-sm">
              <FooterLink to="/nettoyage">Nettoyage automobile</FooterLink>
              <FooterLink to="/mecanique">Petite mécanique</FooterLink>
              <FooterLink to="/textile">Mobilier textile</FooterLink>
              <FooterLink to="/surfaces">Surfaces ext. & locaux</FooterLink>
              <FooterLink to="/galerie">Avant / Après</FooterLink>
              <FooterLink to="/avis">Avis clients</FooterLink>
              <FooterLink to="/nettoyage#reserver">Réserver</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4 font-mono">// Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-white/70 hover:text-white transition-colors">
                <Phone className="w-4 h-4 text-[#E50914] mt-0.5" />
                <a href="tel:0776069799">07 76 06 97 99</a>
              </li>
              <li className="flex items-start gap-2 text-white/70 hover:text-white transition-colors">
                <Mail className="w-4 h-4 text-[#E50914] mt-0.5" />
                <a href="mailto:novacleanservice@outlook.fr" className="break-all">novacleanservice@outlook.fr</a>
              </li>
              <li className="flex items-start gap-2 text-white/70">
                <MapPin className="w-4 h-4 text-[#E50914] mt-0.5" />
                <span>Versailles, France</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Nova Clean Service. Tous droits réservés.</div>
          <div className="font-mono">Nettoyage à domicile · Versailles — France</div>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, children }) {
  return (
    <li>
      <Link to={to} className="text-white/60 hover:text-[#E50914] transition-colors">
        {children}
      </Link>
    </li>
  );
}
